export default __webpack_public_path__ + "static/media/IMG-20210326-WA0052.7437ba3f.jpg";